import { ReactNode, useState } from 'react';
import styled from 'styled-components';
import { alto, portage30 } from '@paradigm/design-system/src/colors';

interface CollapsibleProps {
  readonly children: ReactNode;
  readonly title: string;
}

export default function Collapsible({ title, children }: CollapsibleProps) {
  const [isOpen, setIsOpen] = useState(false);
  const arrow = isOpen ? 'arrow_drop_up' : 'arrow_drop_down';
  const titlePrefix = isOpen ? 'Hide' : 'Show';
  return (
    <CollapsibleContainer>
      <Button type="button" onClick={() => setIsOpen(!isOpen)}>
        <span>{`${titlePrefix} ${title}`}</span>
        <Icon className="material-icons">{arrow}</Icon>
      </Button>
      <ContentContainer isVisible={isOpen}>{children}</ContentContainer>
    </CollapsibleContainer>
  );
}

const ContentContainer = styled.div<{ isVisible: boolean }>`
  transition: all 0.3s ease-in-out;
  max-height: ${({ isVisible }) => (isVisible ? '1000px' : '0')};
  overflow: hidden;
`;

export const CollapsibleContainer = styled.div`
  border: 1px solid ${portage30};
  border-radius: 0.25rem;
  padding: 0 1rem;
`;

const Button = styled.button`
  display: flex;
  width: 100%;
  text-align: left;
  background: none;
  border: none;
  color: white;
  font-size: 1rem;
  font-weight: normal;
  line-height: 1.875rem;
  align-items: center;
  justify-content: space-between;
  padding: 0;
`;

const Icon = styled.i`
  color: ${alto};
`;
